import Vue from "vue";
import Vuex from "vuex";
import dict from "./dictionary-module"
import conf from "./configuration-module"
import layout from "./layout-module"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    dict,
    conf,
    layout
  }
});